import Model from "../Model";
//TODO: Try to resolve issues with exntending from vue-components instead of local copy
//import Model from './components/vue-components/src/models/Model';


export default class StagedCandidateModel extends Model {
    constructor({id, uploadedById, uploadedAt, blobStoreIdentifier, brand, cvSource, externalId, forJobId,
        forename, surname, dateOfBirth, language, email,
        telephone, mobile, street, city, province,
        country, postalCode, jobTitle, salutation, employmentType} = {}) {
            super();
            
        // TODO: Make these fields match with names from api 

        this.addField({
            name: 'id',
            value: id || '',
            validation: {
                required: true
            }
        });

        //TODO: Utalize this field
        this.addField({
            name: 'new',
            value: false
        });

        this.addField({
            name: 'uploadedById',
            value: uploadedById || ''
        });

        this.addField({
            name: 'uploadedAt',
            value: uploadedAt || ''
        });

        this.addField({
            name: 'blobStoreIdentifier',
            value: blobStoreIdentifier || ''
        });

        this.addField({
            name: 'brand',
            value: brand || '',
            validation: {
                required: true
            }
        });

        this.addField({
            name: 'cvSource',
            value: cvSource || '',
            validation: {
                required: true
            }
        });
        
        this.addField({
            name: 'forJobId',
            value: forJobId || ''
        });
        
        this.addField({
            name: 'forCandidateId',
            value: externalId || '',
            validation: {
                length: 18
            }
        });
   
        this.addField({
            name: 'salutation',
            value: salutation ? salutation.value || '' : '', 
            validation: {
                required: true
            }
        });
        
        this.addField({
            name: 'forename',
            value: forename ? forename.value || '' : '',
            validation: {
                required: true
            }
        });

        this.addField({
            name: 'surname',
            value: surname ? surname.value || '' : '',
            validation: {
                required: true
            }
        });

        this.addField({
            name: 'dateOfBirth',
            value: dateOfBirth ? dateOfBirth.value || null : null
        });

        this.addField({
            name: 'language',
            value: language ? language.value || '' : ''
        });

        this.addField({
            name: 'email',
            value: email ? email.value || '' : '',
            validation: {
                required: true,
                regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            }
        });
        
        this.addField({
            name: 'telephone',
            value: telephone ? telephone.value || '' : '',
            //TODO : Phone Validation
            /*validation: {
                regex: '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$'
            }*/
        });
        
        this.addField({
            name: 'mobile',
            value: mobile ? mobile.value || '' : '',
            //TODO : Phone Validation
            /*validation: {
                regex: '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$'
            }*/
        });

        this.addField({
            name: 'street',
            value: street ? street.value || '' : ''
        });

        this.addField({
            name: 'city',
            value: city ? city.value || '' : ''
        });

        this.addField({
            name: 'province',
            value: province ? province.value || '' : ''
        });
        
        this.addField({
            name: 'country',
            value: country ? country.value || '' : '',
            validation: {
                required: true
            }
        });

        this.addField({
            name: 'postalCode',
            value: postalCode ? postalCode.value || '' : '',
            validation: {
                regex: '^[a-zA-Z0-9][a-zA-Z0-9\\- ]{0,10}[a-zA-Z0-9]$'
            }
        });
        
        this.addField({
            name: 'jobTitle',
            value: jobTitle ? jobTitle.value || '' : ''
        });
        
        this.addField({
            name: 'employmentType',
            value: employmentType ? employmentType || '' : '',
            validation: {
                required: true
            }
        });
        

    }
}